const img = require('./arrow_upward_xs_action_secondary.png'); export default img;